const overlapState = new Map();

function checkHeaderOverlap() {
  const header = document.querySelector('.header');
  if (!header) return;

  const headerLogo = header.querySelector('.logo-trigger');
  if (!headerLogo) return;

  const headerLogoRect = headerLogo.getBoundingClientRect();
  const textTags = document.querySelectorAll(
    'h1, h2, h3, h4, h5, h6, p, ul, ol'
  );

  let isAnyOverlapping = false;
  const margin = 0;

  for (const el of textTags) {
    const elRect = el.getBoundingClientRect();

    const isVisible = elRect.width > 0 && elRect.height > 0;

    const verticallyOverlapping =
      headerLogoRect.top - 100 < elRect.bottom - margin &&
      headerLogoRect.bottom > elRect.top + margin;
    const horizontallyOverlapping =
      headerLogoRect.left < elRect.right && headerLogoRect.right > elRect.left;

    const isOverlapping = verticallyOverlapping && horizontallyOverlapping;

    const currentState = overlapState.get(el) || { count: 0, state: false };

    if (isOverlapping !== currentState.state) {
      currentState.count++;
      if (currentState.count >= 5) {
        currentState.state = isOverlapping;
        currentState.count = 0;

        if (isOverlapping) {
          el.classList.add('is-under-header-logo');
        } else {
          el.classList.remove('is-under-header-logo');
        }
      }
    } else {
      currentState.count = 0;
    }

    overlapState.set(el, currentState);
    if (isOverlapping) isAnyOverlapping = true;
  }

  header.classList.toggle('is-over-text', isAnyOverlapping);
}

function throttleWithRaf(callback) {
  let ticking = false;
  return function () {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        callback();
        ticking = false;
      });
      ticking = true;
    }
  };
}

window.checkHeaderOverlapInit = function checkHeaderOverlapInit() {
  if (window.innerWidth > 1024) {
    window.addEventListener('scroll', checkHeaderOverlap, { passive: true });
    window.addEventListener('resize', checkHeaderOverlap);
    document.addEventListener('DOMContentLoaded', checkHeaderOverlap);
  }
};

/*if (!document.querySelector('.bold-loader-new')) {
  checkHeaderOverlapInit();
}*/
